import script from "./ShapeStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShapeStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./ShapeStylePanel.vue?vue&type=style&index=0&id=a79cc22a&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a79cc22a"]])

export default __exports__